import Cookies from 'js-cookie'
import Head from 'next/head'
import Robots from './robots'
import Title from './title'

export default ({ children }) => (
  <Head>
    <meta charSet="utf-8" />
    {process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF !== 'master' && (
      // If we're not in master, show our manually set API environment
      <meta
        name="api_environment"
        content={Cookies.get('api_environment') || 'dev'}
      />
    )}
    {// If a SHA env variable is present, add it as a meta field
    process.env.SHA && <meta name="sha" content={process.env.SHA} />}

    <Robots />

    <Title />

    <link
      // A default transparent favicon
      href="data:image/x-icon;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQEAYAAABPYyMiAAAABmJLR0T///////8JWPfcAAAACXBIWXMAAABIAAAASABGyWs+AAAAF0lEQVRIx2NgGAWjYBSMglEwCkbBSAcACBAAAeaR9cIAAAAASUVORK5CYII="
      rel="icon"
      type="image/x-icon"
    />

    {children}
  </Head>
)
